import {
    BlueLine,
    FAButton,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { styled } from '@/src/stitches.config'

const HowToWrapper = styled('div', {
    width: 410,
    maxWidth: '100%',
    '.blue-text': {
        display: 'flex',
        ai: 'center',
        color: '$secondary',
        fontWeight: 500,
        fontSize: '1.15rem',
    },
    '& span': {
        display: 'inline-flex',
        ml: 10,
    },
    '& p': {
        cursor: 'pointer',
    },
})
const HowToText = styled('div', {
    background: '$white',
    p: 20,
    br: 10,
    '& p': {
        m: 0,
        fontSize: '.85rem',
        lh: '1.25rem',
    },
    '& a': {
        color: '$secondary',
        textTransform: 'none',
        fontWeight: 'bold',
    },
})

const TextDeliveryMessage = ({
    showTextInfo,
    setShowTextInfo,
}: {
    showTextInfo: boolean
    setShowTextInfo: Function
}) => {
    return (
        <HowToWrapper>
            <BlueLine margin={'margin-x-auto'} />
            <p
                className={'blue-text'}
                onClick={() => {
                    setShowTextInfo(!showTextInfo)
                }}
            >
                How BuyGiftCards.com uses text messages{' '}
                <span>
                    <FAButton type={'button'} variant={'simple'} size={'small'}>
                        <FontAwesomeIcon icon={faInfo} />
                    </FAButton>
                </span>
            </p>
            {showTextInfo && (
                <HowToText>
                    <p>
                        BuyGiftCards.com will notify you via text message when
                        your gift is delivered (1 message per gift).
                        BuyGiftCards.com text messaging service is powered by{' '}
                        <a
                            href={'https://www.perfectgift.com'}
                            rel="noopener"
                            target="_blank"
                        >
                            PerfectGift.com
                        </a>
                        . At any time, you can opt out of text messages by
                        replying with STOP. Text HELP for support. Message and
                        data rates may apply. View PerfectGift’s SMS{' '}
                        <a
                            href={
                                'https://www.perfectgift.com/terms-of-service'
                            }
                        >
                            terms of service
                        </a>{' '}
                        and{' '}
                        <a href={'https://www.perfectgift.com/privacy-policy'}>
                            privacy policy
                        </a>
                        .
                    </p>
                </HowToText>
            )}
        </HowToWrapper>
    )
}

export default TextDeliveryMessage
